import Vue from 'vue'
import DialogLoaderComponent from './DialogLoader.vue'

const DialogLoader = {
    install: function(Vue) {
        Vue.component('DialogLoader', DialogLoaderComponent)
    }
}


export default DialogLoader